import type { HistoryStep } from "@/api/analytics";

// Пересчёт шага в ₽/мес для графика.
// market_rate_* — ₽/м²/год → делим на 12 (× площадь). fact_rur_m2_month — уже ₽/м²/мес.
// estimate_*_rur_m2_month — уже ₽/м²/мес полной модели.
// areaSqm=1 оставляет значения в ₽/м² (object-режим, офисы разной площади).
export function stepToRub(s: HistoryStep, areaSqm: number) {
  const m = (r: number | null) => (r != null ? (r * areaSqm) / 12 : null);
  const sqm = (r: number | null) => (r != null ? r * areaSqm : null);
  return {
    p10: m(s.market_rate_p10),
    p50: m(s.market_rate_p50),
    p90: m(s.market_rate_p90),
    fact: s.fact_rur_m2_month != null ? s.fact_rur_m2_month * areaSqm : null,
    estimateLow: sqm(s.estimate_low_rur_m2_month),
    estimate: sqm(s.estimate_rur_m2_month),
    estimateHigh: sqm(s.estimate_high_rur_m2_month),
  };
}
